module.exports = __webpack_public_path__ + "media/chair.72b910ba.mp4";